import React from 'react'
import LtsDropdownIdValue from './lts-dropdown-id-value'
import { enums } from '../../constants'

export default function LtsDropdownTipoChavePix(props) {
  const resolveValueFn = (data) => {
    if (data && data.id && data.value) {
      return data
    }
    return enums.TiposChavesPix.find((v) => v.id === data)
  }

  return (
    <React.Fragment>
      <LtsDropdownIdValue
        name={props.name}
        label={props.label || 'Tipo Chave PIX'}
        value={props.value}
        onChange={props.onChange}
        options={enums.TiposChavesPix}
        resolveValueFn={resolveValueFn}
      />
    </React.Fragment>
  )
}
